var React = require('react');

function BriefcaseMedical (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M192 128h-64V80a48 48 0 0 1 48-48h160a48 48 0 0 1 48 48v48h-64V96H192z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 128H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48zM352 344a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z","className":"fa-primary","key":2})]);
}

BriefcaseMedical.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BriefcaseMedical;

BriefcaseMedical.default = BriefcaseMedical;
